import type React from 'react';

import { ChevronSortIcon } from '@vlabs/icons';
import { DropdownSelect } from '@vlabs/monokit/shared/ui/dropdown-select';
import type { TOption } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

export type TListFacesSortValue =
  | 'create_time_desc'
  | 'create_time_asc'
  | 'user_data_asc'
  | 'user_data_desc';

interface SortListDropdownProps {
  value: TListFacesSortValue;
  onChange: (value: TListFacesSortValue) => void;
  disabled?: boolean;
}

function SortListFacesDropdown({
  value,
  onChange,
  disabled = false,
}: SortListDropdownProps): React.JSX.Element {
  const { t } = useTranslation();

  const options: TOption<TListFacesSortValue>[] = [
    {
      label: t('list-details-page:sort.dropdown_options.date_desc'),
      value: 'create_time_desc',
    },
    {
      label: t('list-details-page:sort.dropdown_options.date_asc'),
      value: 'create_time_asc',
    },
    {
      label: t('list-details-page:sort.dropdown_options.user_data_asc'),
      value: 'user_data_asc',
    },
    {
      label: t('list-details-page:sort.dropdown_options.user_data_desc'),
      value: 'user_data_desc',
    },
  ];

  const selectedOption = options.find((option) => option.value === value);

  return (
    <DropdownSelect
      disabled={disabled}
      icon={<ChevronSortIcon />}
      label={selectedOption?.label ?? ''}
      onSelect={onChange}
      options={options}
      value={value}
    />
  );
}

export { SortListFacesDropdown };
